import { render, staticRenderFns } from "./InputTextarea.vue?vue&type=template&id=45897230"
import script from "./InputTextarea.vue?vue&type=script&lang=js"
export * from "./InputTextarea.vue?vue&type=script&lang=js"
import style0 from "./InputTextarea.vue?vue&type=style&index=0&id=45897230&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports